import { FC } from 'react';
import { EnumDropdownProps } from 'src/models/FieldProps.interface';
import { PaymentMode } from 'src/models/enums/PaymentMode.enum';
import {
  ContainerBox,
  LabelTypography,
  StyledFormControl,
} from './PaymentModePicker.styles';
import FormikSelectField from './FormikSelectField';

const paymentModeOptions = [
  { value: PaymentMode.CASH, label: 'Cash' },
  { value: PaymentMode.CHEQUE, label: 'Cheque' },
  { value: PaymentMode.ONLINE, label: 'Online Transfer' },
];

const PaymentModePicker: FC<EnumDropdownProps> = ({
  id,
  label,
  formikProps,
  errorState = false,
  height = '40px',
  width = '450px',
  showLabel = true,
  customMessage,
  textColor = 'var(--primary-navy)',
  fontSize = '16px',
  fontWeight = '400',
  borderColor = 'var(--border)',
}) => {
  const hasError =
    (formikProps.touched[id] && Boolean(formikProps.errors[id])) || errorState;

  return (
    <ContainerBox>
      {showLabel && (
        <LabelTypography
          fontWeight={fontWeight}
          fontSize={fontSize}
          textColor={textColor}
        >
          {label}
        </LabelTypography>
      )}
      <StyledFormControl fullWidth error={hasError}>
        <FormikSelectField
          id={id}
          label={label}
          formikProps={formikProps}
          options={paymentModeOptions}
          errorState={errorState}
          height={height}
          width={width}
          borderColor={borderColor}
          fontSize={fontSize}
          fontWeight={fontWeight}
          showLabel={false}
          customMessage={customMessage}
        />
      </StyledFormControl>
    </ContainerBox>
  );
};

export default PaymentModePicker;
